import { BugReport } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "../../controls/forms/buttons/button";
import { ErrorBoundaryQaThrow } from "./error-boundary-qa-throw.component";
import { ErrorBoundaryQaPanelStyled } from "./error-boundary-qa.panel.styled";
import { useErrorBoundaryQaPanel } from "./use-error-boundary-qa.panel";

export const ErrorBoundaryQaPanel: FC = () => {
  const { t } = useTranslation();
  const { pendingError, handleGenerateErrorClick } = useErrorBoundaryQaPanel();

  return (
    <ErrorBoundaryQaPanelStyled>
      <h2>{t("controls.errorBoundaryQaSection", "Error boundary (QA)")}</h2>
      <MuiButton
        muiStyle="error"
        startIcon={<BugReport />}
        onClick={handleGenerateErrorClick}
      >
        {t("controls.generateError", "Generate error")}
      </MuiButton>
      <ErrorBoundaryQaThrow error={pendingError} />
    </ErrorBoundaryQaPanelStyled>
  );
};
